<template>
  <div>
    <div class="intro-y flex items-center mt-8">
      <h2 class="text-lg font-medium mr-auto">Project Analytics</h2>
    </div>
    <Table class="mt-5"></Table>
  </div>
</template>

<script>
import Table from "../../components/Core/UTableProjectAnalytics.vue";
export default {
  components: {
    Table
  },
  data() {
    return {
      isModal: true
    };
  }
};
</script>
